const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function rupees(paise: number): string {
  const r = paise / 100;
  return '₹' + (Number.isInteger(r) ? r.toString() : r.toFixed(2));
}

export function date(ts: number): string {
  const d = new Date(ts);
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function clock(s: number): string {
  const t = Math.max(0, Math.floor(s));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
}

export function minutes(s: number): string {
  const m = Math.round(s / 60);
  return m < 1 ? '<1 min' : `${m} min`;
}

export function ago(ts: number): string {
  const m = Math.round((Date.now() - ts) / 60000);
  if (m < 1) return 'Just now';
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hour${h > 1 ? 's' : ''} ago`;
  const d = Math.round(h / 24);
  return d === 1 ? 'Yesterday' : `${d} days ago`;
}

export function maskPhone(phone: string): string {
  return `+91 ${phone.slice(0, 2)}XXX X${phone.slice(-4)}`;
}
